var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper has-border"},[(_vm.disabled)?_c('div',{staticClass:"overlay"}):_vm._e(),_c('froala',{attrs:{"tag":'textarea',"config":_vm.config},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }